import * as React from "react";

function SvgJumpToDate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" {...props}>
      <path
        d="M9.957 7L7 9.957l4.435 4.434-2.957 2.957h8.87v-8.87l-2.957 2.957L9.957 7zM20.304 25.232h2.957v2.956h-2.957v-2.956zM25.232 25.232h2.956v2.956h-2.956v-2.956zM30.16 25.232h2.956v2.956h-2.957v-2.956zM35.087 25.232h2.956v2.956h-2.956v-2.956zM20.304 30.16h2.957v2.956h-2.957v-2.957zM25.232 30.16h2.956v2.956h-2.956v-2.957zM30.16 30.16h2.956v2.956h-2.957v-2.957zM35.087 30.16h2.956v2.956h-2.956v-2.957zM20.304 35.087h2.957v2.956h-2.957v-2.956zM25.232 35.087h2.956v2.956h-2.956v-2.956zM30.16 35.087h2.956v2.956h-2.957v-2.956zM35.087 35.087h2.956v2.956h-2.956v-2.956z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.275 17.348h2.957v.985h7.884v-.985h2.956v.985h1.971A2.957 2.957 0 0141 21.29V41H17.348V21.29a2.957 2.957 0 012.956-2.957h1.971v-.985zm-3.942 5.913v16.753h21.681V23.261h-21.68z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgJumpToDate;
